import { Component, TemplateRef } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { TableColumn } from '../interfaces';

export interface TemplateCellRendererParams extends ICellRendererParams {
    /** The `columnTemplate` / `rowActions` ng-template to render */
    template: TemplateRef<unknown>;
    tableColumn?: TableColumn;
}

/**
 * Renders an existing static-table style ng-template inside an AG Grid cell,
 * so the dialogue's `columnTemplate` and `rowActions` templates are reused
 * unchanged. Rows are RenderedRow wrappers, so the original row is `data.data`.
 */
@Component({
    selector: 'template-cell-renderer',
    template: `
        <ng-container
            *ngIf="params?.template"
            [ngTemplateOutlet]="params.template"
            [ngTemplateOutletContext]="{
                row: params.data?.data,
                column: params.tableColumn
            }"
        ></ng-container>
    `
})
export class TemplateCellRenderer implements ICellRendererAngularComp {
    params: TemplateCellRendererParams;

    agInit(params: TemplateCellRendererParams) {
        this.params = params;
    }

    refresh(params: TemplateCellRendererParams) {
        this.params = params;
        return true;
    }
}
